import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { SearchBar } from '@/components/search/SearchBar';
import { RecentSearches } from '@/components/search/RecentSearches';
import { PopularSearches } from '@/components/search/PopularSearches';
import { SearchResults } from '@/components/search/SearchResults';
import { useSearchStore } from '@/store/search';

// 임시 인기 검색어 데이터
const POPULAR_SEARCHES = [
  { id: '1', query: '치킨', rank: 1 },
  { id: '2', query: '피자', rank: 2 },
  { id: '3', query: '햄버거', rank: 3 },
  { id: '4', query: '김밥', rank: 4 },
  { id: '5', query: '샐러드', rank: 5 },
  { id: '6', query: '도시락', rank: 6 },
  { id: '7', query: '파스타', rank: 7 },
  { id: '8', query: '초밥', rank: 8 },
  { id: '9', query: '강남역', rank: 9 },
  { id: '10', query: '종로', rank: 10 }
]

export default function SearchPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const { 
    searchQuery, 
    setSearchQuery, 
    recentSearches, 
    addRecentSearch, 
    removeRecentSearch, 
    clearRecentSearches 
  } = useSearchStore();

  // URL의 쿼리 파라미터와 상태 동기화
  useEffect(() => {
    const query = searchParams.get('q') || '';
    setSearchQuery(query);
  }, [searchParams, setSearchQuery]);

  const handleSearchChange = (value: string) => {
    setSearchQuery(value);
    // URL 업데이트 (히스토리 추가하지 않음)
    if (value) {
      setSearchParams({ q: value }, { replace: true });
    } else {
      setSearchParams({}, { replace: true });
    }
  };

  const handleSearch = () => {
    if (searchQuery.trim()) {
      addRecentSearch(searchQuery);
    }
  };

  const handleRecentSearchClick = (query: string) => {
    setSearchQuery(query);
    setSearchParams({ q: query }, { replace: true });
    addRecentSearch(query);
  };

  const handlePopularSearchClick = (query: string) => {
    setSearchQuery(query);
    setSearchParams({ q: query }, { replace: true });
    addRecentSearch(query);
  };

  const handleResultClick = (restaurantId: string) => {
    navigate(`/store/${restaurantId}`);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* 검색바 */}
      <SearchBar
        value={searchQuery}
        onChange={handleSearchChange}
        onSearch={handleSearch}
        autoFocus
      />

      {/* 검색 결과 또는 초기 화면 */}
      {searchQuery ? (
        <SearchResults 
          query={searchQuery}
          onResultClick={handleResultClick}
        />
      ) : (
        <>
          <RecentSearches
            searches={recentSearches}
            onSearchClick={handleRecentSearchClick}
            onSearchRemove={removeRecentSearch}
            onClearAll={clearRecentSearches}
          />
          <PopularSearches
            searches={POPULAR_SEARCHES}
            onSearchClick={handlePopularSearchClick}
          />
        </>
      )}
    </div>
  );
}